module.exports = __webpack_public_path__ + "static/media/Crash808.039b2daf.wav";